// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.InfluencerRegistration_entry-component__sz7Km{
    width: 100vw;
    height: 54vw;
    margin-top: -5vw;
}

.InfluencerRegistration_entry-img__nidLJ{
    width: 100vw;
    height: 54vw;
    object-fit: cover;
    position: absolute;
    z-index: -1;
}

.InfluencerRegistration_entry-content__At-6p{
    width: 40vw;
    height: 20vw;
    position: absolute;
    margin-top: 15vw;
    margin-left: 10vw;
    
}

.InfluencerRegistration_entry-heading__5\\+y8U{
    font-size: 6vw;
    margin-top: 0;
    margin-bottom: 1vw;
    font-weight: 500;
}

.InfluencerRegistration_entry-text__nQFf8{
    font-size: 1.2vw;
    font-weight: 300;
    margin-bottom: 0;
    margin-top:0.5vw;
}

.InfluencerRegistration_inf-rgstr-frm-container__pzNNx{
    /* border: 2px solid black; */
    margin: auto;
    margin-top: 1vw;
    margin-bottom: 5vw;
    width: 66vw;
    height: 91vw;
    border-radius: 2vw;
}

.InfluencerRegistration_form-heading__aPHKY{
    font-size: 2.2vw;
    text-align: center;
}

.InfluencerRegistration_question-text__bXUmt{
    margin-top: 1vw;
    margin-bottom: 0.5vw;
    margin-left: 3vw;
    font-size: 1.4vw;
    font-weight: 300;
}

.InfluencerRegistration_input-text__OyRvs{
    margin-top: 0;
    margin-left: 3vw;
    width: 60vw;
    height: 2.7vw;
    border-radius: 100vw;
    border: 1px solid black;
    margin-bottom: 1vw;
    font-size: 1.4vw;
    padding-left: 1vw;
    padding-right: 1vw;
    box-sizing: border-box;
}

.InfluencerRegistration_insta-follower-radio__xxAAA{
    display: flex;
    flex-direction: column;
    margin-left: 3vw;
    font-size: 1.2vw;
    font-weight: 200;
    line-height: 2vw;
}

.InfluencerRegistration_insta-follower-options__1W-Xs{
    margin-right: 1.2vw;
    cursor: pointer;
    height: 1vw;
    width: 1vw;
}

.InfluencerRegistration_follower-label__bNXx8{
    cursor: pointer;
}

.InfluencerRegistration_insta-checkbox__Qjyu-{
    display: flex;
    flex-direction: column;
    margin-left: 3vw;
    font-size: 1.2vw;
    font-weight: 200;
    line-height: 2vw;
}

.InfluencerRegistration_insta-checkbx__39mFw{
    margin-right: 1.2vw;
    cursor: pointer;
    height: 1vw;
    width: 1vw;
}

.InfluencerRegistration_insta-label__1FkBs{
    cursor: pointer;
}

.InfluencerRegistration_submit-button__HAkO0{
    width: 15vw;
    height: 3.5vw;
    border-radius: 0.5vw;
    background-color: #e65439;
    color: white;
    font-size: 1.5vw;
    margin-left: 25.5vw;
    margin-top: 2vw;
    border: none;
    cursor: pointer;
}

@media(max-width: 768px){
    .InfluencerRegistration_entry-component__sz7Km{
        width: 100vw;
        height: 54vw;
        margin-top: -13vw;
    }
    
    .InfluencerRegistration_entry-img__nidLJ{
        width: 100vw;
        height: 54vw;
        object-fit: cover;
        position: absolute;
        z-index: -1;
        /* display: none; */
    }
    
    .InfluencerRegistration_entry-content__At-6p{
        width: 55vw;
        height: 20vw;
        position: absolute;
        margin-top: 15vw;
        margin-left: 7vw;
        
    }

    .InfluencerRegistration_entry-heading__5\\+y8U{
        font-size: 7vw;
        margin-top: 0;
        margin-bottom: 1vw;
        font-weight: 500;
    }
    
    .InfluencerRegistration_entry-text__nQFf8{
        font-size: 2.5vw;
        font-weight: 300;
        margin-bottom: 0;
        margin-top:1vw;
    }
    
    .InfluencerRegistration_inf-rgstr-frm-container__pzNNx{
        /* border: 2px solid black; */
        margin: auto;
        margin-top: 5vw;
        margin-bottom: 5vw;
        width: 90vw;
        height: 235vw;
        border-radius: 5vw;
    }
    
    .InfluencerRegistration_form-heading__aPHKY{
        font-size: 6vw;
        text-align: center;
    }
    
    .InfluencerRegistration_question-text__bXUmt{
        margin-top: 1vw;
        margin-bottom: 0.5vw;
        margin-left: 3vw;
        font-size: 3.5vw;
        font-weight: 300;
    }
    
    .InfluencerRegistration_input-text__OyRvs{
        margin-top: 0;
        margin-left: 3vw;
        width: 84vw;
        height: 9vw;
        border-radius: 100vw;
        border: 1px solid black;
        margin-bottom: 1vw;
        font-size: 3.5vw;
        padding-left: 3vw;
        padding-right: 3vw;
        box-sizing: border-box;
    }

    .InfluencerRegistration_follower-label__bNXx8{
        display: flex;
        flex-direction: row;
        height: 5vw;
        margin-bottom: 1vw;
    }
    
    .InfluencerRegistration_insta-follower-radio__xxAAA{
        display: flex;
        flex-direction: column;
        margin-left: 3vw;
        font-size: 3vw;
        font-weight: 200;
        line-height: 6vw;
    }
    
    .InfluencerRegistration_insta-follower-options__1W-Xs{
        margin-right: 3vw;
        cursor: pointer;
        align-self: center;
        justify-self: center;
        height: auto;
        width: auto;
    }

    .InfluencerRegistration_insta-label__1FkBs{
        display: flex;
        flex-direction: row;
        height: 6vw;
        margin-bottom: 1vw;
    }
    
    .InfluencerRegistration_insta-checkbox__Qjyu-{
        display: flex;
        flex-direction: column;
        margin-left: 3vw;
        font-size: 3vw;
        font-weight: 200;
        line-height: 6vw;
    }
    
    .InfluencerRegistration_insta-checkbx__39mFw{
        margin-right: 3vw;
        cursor: pointer;
        height: auto;
        width: auto;
    }
    
    .InfluencerRegistration_submit-button__HAkO0{
        width: 50vw;
        height: 10vw;
        border-radius: 2vw;
        background-color: #e65439;
        color: white;
        font-size: 5vw;
        margin-left: 20vw;
        margin-top: 5vw;
        border: none;
        cursor: pointer;
    }
}`, "",{"version":3,"sources":["webpack://./src/Pages/InfluencerRegistration/InfluencerRegistration.module.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;;AAErB;;AAEA;IACI,cAAc;IACd,aAAa;IACb,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,6BAA6B;IAC7B,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,oBAAoB;IACpB,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,WAAW;IACX,aAAa;IACb,oBAAoB;IACpB,uBAAuB;IACvB,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,eAAe;IACf,WAAW;IACX,UAAU;AACd;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,eAAe;IACf,WAAW;IACX,UAAU;AACd;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,oBAAoB;IACpB,yBAAyB;IACzB,YAAY;IACZ,gBAAgB;IAChB,mBAAmB;IACnB,eAAe;IACf,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI;QACI,YAAY;QACZ,YAAY;QACZ,iBAAiB;IACrB;;IAEA;QACI,YAAY;QACZ,YAAY;QACZ,iBAAiB;QACjB,kBAAkB;QAClB,WAAW;QACX,mBAAmB;IACvB;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,kBAAkB;QAClB,gBAAgB;QAChB,gBAAgB;;IAEpB;;IAEA;QACI,cAAc;QACd,aAAa;QACb,kBAAkB;QAClB,gBAAgB;IACpB;;IAEA;QACI,gBAAgB;QAChB,gBAAgB;QAChB,gBAAgB;QAChB,cAAc;IAClB;;IAEA;QACI,6BAA6B;QAC7B,YAAY;QACZ,eAAe;QACf,kBAAkB;QAClB,WAAW;QACX,aAAa;QACb,kBAAkB;IACtB;;IAEA;QACI,cAAc;QACd,kBAAkB;IACtB;;IAEA;QACI,eAAe;QACf,oBAAoB;QACpB,gBAAgB;QAChB,gBAAgB;QAChB,gBAAgB;IACpB;;IAEA;QACI,aAAa;QACb,gBAAgB;QAChB,WAAW;QACX,WAAW;QACX,oBAAoB;QACpB,uBAAuB;QACvB,kBAAkB;QAClB,gBAAgB;QAChB,iBAAiB;QACjB,kBAAkB;QAClB,sBAAsB;IAC1B;;IAEA;QACI,aAAa;QACb,mBAAmB;QACnB,WAAW;QACX,kBAAkB;IACtB;;IAEA;QACI,aAAa;QACb,sBAAsB;QACtB,gBAAgB;QAChB,cAAc;QACd,gBAAgB;QAChB,gBAAgB;IACpB;;IAEA;QACI,iBAAiB;QACjB,eAAe;QACf,kBAAkB;QAClB,oBAAoB;QACpB,YAAY;QACZ,WAAW;IACf;;IAEA;QACI,aAAa;QACb,mBAAmB;QACnB,WAAW;QACX,kBAAkB;IACtB;;IAEA;QACI,aAAa;QACb,sBAAsB;QACtB,gBAAgB;QAChB,cAAc;QACd,gBAAgB;QAChB,gBAAgB;IACpB;;IAEA;QACI,iBAAiB;QACjB,eAAe;QACf,YAAY;QACZ,WAAW;IACf;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,kBAAkB;QAClB,yBAAyB;QACzB,YAAY;QACZ,cAAc;QACd,iBAAiB;QACjB,eAAe;QACf,YAAY;QACZ,eAAe;IACnB;AACJ","sourcesContent":[".entry-component{\n    width: 100vw;\n    height: 54vw;\n    margin-top: -5vw;\n}\n\n.entry-img{\n    width: 100vw;\n    height: 54vw;\n    object-fit: cover;\n    position: absolute;\n    z-index: -1;\n}\n\n.entry-content{\n    width: 40vw;\n    height: 20vw;\n    position: absolute;\n    margin-top: 15vw;\n    margin-left: 10vw;\n    \n}\n\n.entry-heading{\n    font-size: 6vw;\n    margin-top: 0;\n    margin-bottom: 1vw;\n    font-weight: 500;\n}\n\n.entry-text{\n    font-size: 1.2vw;\n    font-weight: 300;\n    margin-bottom: 0;\n    margin-top:0.5vw;\n}\n\n.inf-rgstr-frm-container{\n    /* border: 2px solid black; */\n    margin: auto;\n    margin-top: 1vw;\n    margin-bottom: 5vw;\n    width: 66vw;\n    height: 91vw;\n    border-radius: 2vw;\n}\n\n.form-heading{\n    font-size: 2.2vw;\n    text-align: center;\n}\n\n.question-text{\n    margin-top: 1vw;\n    margin-bottom: 0.5vw;\n    margin-left: 3vw;\n    font-size: 1.4vw;\n    font-weight: 300;\n}\n\n.input-text{\n    margin-top: 0;\n    margin-left: 3vw;\n    width: 60vw;\n    height: 2.7vw;\n    border-radius: 100vw;\n    border: 1px solid black;\n    margin-bottom: 1vw;\n    font-size: 1.4vw;\n    padding-left: 1vw;\n    padding-right: 1vw;\n    box-sizing: border-box;\n}\n\n.insta-follower-radio{\n    display: flex;\n    flex-direction: column;\n    margin-left: 3vw;\n    font-size: 1.2vw;\n    font-weight: 200;\n    line-height: 2vw;\n}\n\n.insta-follower-options{\n    margin-right: 1.2vw;\n    cursor: pointer;\n    height: 1vw;\n    width: 1vw;\n}\n\n.follower-label{\n    cursor: pointer;\n}\n\n.insta-checkbox{\n    display: flex;\n    flex-direction: column;\n    margin-left: 3vw;\n    font-size: 1.2vw;\n    font-weight: 200;\n    line-height: 2vw;\n}\n\n.insta-checkbx{\n    margin-right: 1.2vw;\n    cursor: pointer;\n    height: 1vw;\n    width: 1vw;\n}\n\n.insta-label{\n    cursor: pointer;\n}\n\n.submit-button{\n    width: 15vw;\n    height: 3.5vw;\n    border-radius: 0.5vw;\n    background-color: #e65439;\n    color: white;\n    font-size: 1.5vw;\n    margin-left: 25.5vw;\n    margin-top: 2vw;\n    border: none;\n    cursor: pointer;\n}\n\n@media(max-width: 768px){\n    .entry-component{\n        width: 100vw;\n        height: 54vw;\n        margin-top: -13vw;\n    }\n    \n    .entry-img{\n        width: 100vw;\n        height: 54vw;\n        object-fit: cover;\n        position: absolute;\n        z-index: -1;\n        /* display: none; */\n    }\n    \n    .entry-content{\n        width: 55vw;\n        height: 20vw;\n        position: absolute;\n        margin-top: 15vw;\n        margin-left: 7vw;\n        \n    }\n\n    .entry-heading{\n        font-size: 7vw;\n        margin-top: 0;\n        margin-bottom: 1vw;\n        font-weight: 500;\n    }\n    \n    .entry-text{\n        font-size: 2.5vw;\n        font-weight: 300;\n        margin-bottom: 0;\n        margin-top:1vw;\n    }\n    \n    .inf-rgstr-frm-container{\n        /* border: 2px solid black; */\n        margin: auto;\n        margin-top: 5vw;\n        margin-bottom: 5vw;\n        width: 90vw;\n        height: 235vw;\n        border-radius: 5vw;\n    }\n    \n    .form-heading{\n        font-size: 6vw;\n        text-align: center;\n    }\n    \n    .question-text{\n        margin-top: 1vw;\n        margin-bottom: 0.5vw;\n        margin-left: 3vw;\n        font-size: 3.5vw;\n        font-weight: 300;\n    }\n    \n    .input-text{\n        margin-top: 0;\n        margin-left: 3vw;\n        width: 84vw;\n        height: 9vw;\n        border-radius: 100vw;\n        border: 1px solid black;\n        margin-bottom: 1vw;\n        font-size: 3.5vw;\n        padding-left: 3vw;\n        padding-right: 3vw;\n        box-sizing: border-box;\n    }\n\n    .follower-label{\n        display: flex;\n        flex-direction: row;\n        height: 5vw;\n        margin-bottom: 1vw;\n    }\n    \n    .insta-follower-radio{\n        display: flex;\n        flex-direction: column;\n        margin-left: 3vw;\n        font-size: 3vw;\n        font-weight: 200;\n        line-height: 6vw;\n    }\n    \n    .insta-follower-options{\n        margin-right: 3vw;\n        cursor: pointer;\n        align-self: center;\n        justify-self: center;\n        height: auto;\n        width: auto;\n    }\n\n    .insta-label{\n        display: flex;\n        flex-direction: row;\n        height: 6vw;\n        margin-bottom: 1vw;\n    }\n    \n    .insta-checkbox{\n        display: flex;\n        flex-direction: column;\n        margin-left: 3vw;\n        font-size: 3vw;\n        font-weight: 200;\n        line-height: 6vw;\n    }\n    \n    .insta-checkbx{\n        margin-right: 3vw;\n        cursor: pointer;\n        height: auto;\n        width: auto;\n    }\n    \n    .submit-button{\n        width: 50vw;\n        height: 10vw;\n        border-radius: 2vw;\n        background-color: #e65439;\n        color: white;\n        font-size: 5vw;\n        margin-left: 20vw;\n        margin-top: 5vw;\n        border: none;\n        cursor: pointer;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"entry-component": `InfluencerRegistration_entry-component__sz7Km`,
	"entry-img": `InfluencerRegistration_entry-img__nidLJ`,
	"entry-content": `InfluencerRegistration_entry-content__At-6p`,
	"entry-heading": `InfluencerRegistration_entry-heading__5+y8U`,
	"entry-text": `InfluencerRegistration_entry-text__nQFf8`,
	"inf-rgstr-frm-container": `InfluencerRegistration_inf-rgstr-frm-container__pzNNx`,
	"form-heading": `InfluencerRegistration_form-heading__aPHKY`,
	"question-text": `InfluencerRegistration_question-text__bXUmt`,
	"input-text": `InfluencerRegistration_input-text__OyRvs`,
	"insta-follower-radio": `InfluencerRegistration_insta-follower-radio__xxAAA`,
	"insta-follower-options": `InfluencerRegistration_insta-follower-options__1W-Xs`,
	"follower-label": `InfluencerRegistration_follower-label__bNXx8`,
	"insta-checkbox": `InfluencerRegistration_insta-checkbox__Qjyu-`,
	"insta-checkbx": `InfluencerRegistration_insta-checkbx__39mFw`,
	"insta-label": `InfluencerRegistration_insta-label__1FkBs`,
	"submit-button": `InfluencerRegistration_submit-button__HAkO0`
};
export default ___CSS_LOADER_EXPORT___;
